import { colors } from 'settings/colors'
import { useIsWideScreen } from 'utils/useIsWideScreen'

export const ItemHeader = ({ children }: { children: React.ReactNode }) => {
  const isWideScreen = useIsWideScreen()

  if (!isWideScreen) return null

  return (
    <div
      css={{
        margin: '20px',
        padding: '20px',
        height: '63px',
        fontSize: '20px',
        borderBottom: `1px solid ${colors.grey200}`,
        fontWeight: 'bold',
      }}
    >
      {children}
    </div>
  )
}
